import { Box } from "@material-ui/core";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import React from "react";
import { ActionFC } from "./types";

const Action: ActionFC = ({ title, children }) => (
  <Box
    gap={1}
    display={"flex"}
    flexWrap={"wrap"}
    alignItems={"center"}
    pl={2}
    pt={2}
  >
    <Grid item>
      <FormLabel sx={{ lineHeight: 2 }}>{title}</FormLabel>
    </Grid>
    <Grid item>{children}</Grid>
  </Box>
);

export default Action;
